const _temp0 = require("./PlayerShip/player.weapon.js");


const _temp1 = require("./sinterklaas/sintWeapons.weapon.ts");

const _temp2 = require("./sinterklaas/Jinte/player.weapon.js");



const _temp3 = require("./test/test.weapon.js");

const _temp4 = require("./test/turret.weapon.js");


const _temp5 = require("./enemies/BulletCannon/bulletCannon.weapon.js");


const _temp6 = require("./enemies/BulletDrone/bulletDrone.weapon.js");


const _temp7 = require("./enemies/Helicopter/helicopter.weapon.js");


const _temp8 = require("./enemies/LargeDrone/largeDrone.weapon.js");


const _temp9 = require("./enemies/LaserCannon/laserCannon.weapon.js");


const _temp10 = require("./enemies/Mine/mine.weapon.js");



module.exports = {
  "PlayerShip":   {
    "player":     {
      "js": _temp0
    }
  },
  "sinterklaas":   {
    "sintWeapons":     {
      "ts": _temp1
    },
    "Jinte":     {
      "player":       {
        "js": _temp2
      }
    }
  },
  "test":   {
    "test":     {
      "js": _temp3
    },
    "turret":     {
      "js": _temp4
    }
  },
  "enemies":   {
    "BulletCannon":     {
      "bulletCannon":       {
        "js": _temp5
      }
    },
    "BulletDrone":     {
      "bulletDrone":       {
        "js": _temp6
      }
    },
    "Helicopter":     {
      "helicopter":       {
        "js": _temp7
      }
    },
    "LargeDrone":     {
      "largeDrone":       {
        "js": _temp8
      }
    },
    "LaserCannon":     {
      "laserCannon":       {
        "js": _temp9
      }
    },
    "Mine":     {
      "mine":       {
        "js": _temp10
      }
    }
  }
}